/**
 * Creates a link and clicks it based on a file mine type, name and blob. Will cleanup
 * tag create after being triggered.
 *
 * @param type File mime type
 * @param filename Filename
 * @param data File blob
 */
export function downloadLink(type: string, filename: string, data: string) {
	const base64 = 'data:' + type + ';base64, ' + data;
	const linkObject = document.createElement('a');

	if (base64) {
		linkObject.href = base64;
		linkObject.download = filename;
		linkObject.click();
		linkObject.remove();
	}
}
